<template>
  <div class="parent">
    <banner v-bind:bannerObj="bannerObj"></banner>
    <div class="pro-content">
      <div class="serviceWrap">
        <div class="elementItem">
          <div class="img">
            <img src="../assets/images/bank.png" alt>
          </div>
          <div class="itemText">
            <div>
              <span>01</span>
              <i>一站式跨境金融服务</i>
            </div>
            <p>专注为跨境企业和个人客户提供国际收付、货币兑换、供应链融资、汇率风险管理方案等一站式跨境金融服务。</p>
            <router-link to="/detail">了解更多</router-link>
            <router-view></router-view>
          </div>
        </div>
      </div>
      <div class="serviceWrap backColor">
        <div class="elementItem">
          <div class="itemText">
            <div>
              <span>02</span>
              <i>电商解决方案</i>
            </div>
            <p>提供各类电商解决方案，帮助您拓展跨境市场，一对一为制造企业提供交易场景互联网化的解决方案。</p>
            <router-link to="/shop">了解更多</router-link>
            <router-view></router-view>
          </div>
          <div class="img">
            <img src="../assets/images/road.png" alt>
          </div>
        </div>
      </div>
      <div class="serviceWrap">
        <div class="elementItem">
          <div class="img">
            <img src="../assets/images/ipad.png" alt>
          </div>
          <div class="itemText">
            <div>
              <span>03</span>
              <i>金融系统开发</i>
            </div>
            <p>一站式解决跨境交易中各类金融系统的开发和技术维护问题，为客户提供从平台前端到后台系统管理、从风控管理到售后技术服务的全方位解决方案。</p>
            <router-link to="/system">了解更多</router-link>
            <router-view></router-view>
          </div>
        </div>
      </div>
      <!--<div class="serviceWrap backColor">-->
        <!--<div class="elementItem">-->
          <!--<div class="itemText">-->
            <!--<div>-->
              <!--<span>04</span>-->
              <!--<i>电商增值服务</i>-->
            <!--</div>-->
            <!--<p>互联网商城（独立品牌） “中国街” 交易场景互联网化。</p>-->
            <!--<router-link to="/appreciation">了解更多</router-link>-->
            <!--<router-view></router-view>-->
          <!--</div>-->
          <!--<div class="img">-->
            <!--<img src="../assets/images/compute.png" alt>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <footer>
      <footContent></footContent>
    </footer>
  </div>
</template>

<style lang="scss">
.parent {
  background-color: #fff;
}
.pro-content {
  width: 100%;
  height: auto;
  .serviceWrap {
    width: 100%;
    padding: 50px 0;
  }
  .backColor {
    background: #fbfcfc;
  }
  .elementItem {
    width: 1120px;
    margin: 60px auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    div.img {
      img {
        display: block;
        width: 442px;
        height: 261px;
      }
    }
    .itemText {
      width: 600px;
      position: relative;
      div {
        margin-bottom: 20px;
        span {
          text-indent: 0;
          font-size: 100px;
          color: rgba(0, 0, 0, 0.06);
          font-weight: bold;
        }
        i {
          font-family: NewPingfangMedium;
          font-size: 30px;
          color: #323232;
          margin-left: -70px;
        }
      }
      p {
        font-family: NewPingfangMedium;
        font-size: 16px;
        color: rgba(50, 50, 50, 0.79);
        line-height: 30px;
      }
      a {
        display: block;
        color: #5f51d7;
        border: 1px solid #5f51d7;
        padding: 4px 6px;
        width: 80px;
        font-size: 14px;
        font-family: NewPingfang;
        text-align: center;
        position: absolute;
        bottom: -20px;
        right: 0;
      }
    }
  }
}
</style>


<script>
import store from "../vuex";
import DetailBanner from "../components/DetailBanner";
import FootContent from "../components/FootContent.vue";

// import Child from '../components/Child.vue'
export default {
  data() {
    return {
      bannerObj: {
        imgUrl: require("../assets/images/products.png"),
        text: "PRODUCTS & SOLUTIONS"
      }
    };
  },
  components: {
    banner: DetailBanner,
    footContent: FootContent
  },
  store
};
</script>

